import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"
import Icon from "@irati/ui/src/Icon"
import {FormattedMessage} from "@irati/utils/lang"
import {Label2} from "@irati/ui/src/Labels"
import {convertProximity} from "../../helpers/proximity"

const InverseGeoPin = styled(Icon)`
  stroke: ${greys.mediumDark};
`

const Container = styled.div`
  color: ${greys.mediumDark};
`

const NearestLocation = styled.div`
  display: flex;
  align-items: center;

  ${InverseGeoPin}{
    margin-right: 5px;
  }
`

class Proximity extends PureComponent {
  static propTypes = {
    proximityMeters: PropTypes.number.isRequired,
    locations: PropTypes.array.isRequired,
    className: PropTypes.string
  }

  static defaultProps = {
    className: null
  }

  render() {
    const {className, proximityMeters, locations} = this.props
    const proximity = convertProximity(proximityMeters)
    const locationsCount = locations.length
    return (
      <Container className={className}>
        <NearestLocation>
          <InverseGeoPin color={greys.white} icon="geoPin" size={12} />
          <Label2><FormattedMessage id="geolocation.components.proximity.text" values={{proximity}} /></Label2>
        </NearestLocation>
        {locationsCount > 1 &&
          <Label2>
            <FormattedMessage id="geolocation.components.proximity.locations.text" values={{locationsCount: locationsCount - 1}} />
          </Label2>
        }
      </Container>
    )
  }
}

export default Proximity
